<template>

<div>
    <nav class="sticky w-full z-50 top-0 " >
        
        <navBar/>
    </nav>

    <!-- <NavBar2/> -->



    <div class=" pt-6">

        <!-- HERO SECTION -->
        <div class="  px-2 pt-7 md:px-20 font-euclid justify-between md:flex-row flex flex-col ">
            <div class="md:mx-1 md:mt-28 sm:mt-12 md:text-left text-justify">
                <h1 class="md:text-5xl text-center text-3xl md:text-justify text-black  font-semibold ">Automated medication <br> reminder for pharmacies <br> and hospitals</h1>
                <div class="w-auto sm:items-center">
                    <h1 class="text-xl md:text-3xl text-center md:text-left font-medium mt-8 text-medalertBlue ">Never miss a dose again!</h1>

                    <div class="flex mt-6 md:order-2 justify-center md:justify-start">
                        <router-link to="/register" ><button type="button" class="text-white md:w-full bg-medalertBlue hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg md:text-lg text-md px-10 md:px-20 py-3 text-center md:mr-3 dark:bg-purple dark:hover:bg-blueHover  dark:focus:ring-purple font-euclid ">Get started for free</button></router-link>
                    </div>
                </div>
            </div>
            
            
            <div class="mt-20 md:mt-0">
                <img src="../assets/images/Herobanner1.png" alt="" class=" md:w-5/5">
            </div>
        </div>

        <div class="flex flex-col-reverse px-2 my-10 py-8  md:px-20  w-full font-euclid  md:flex-row ">
            <img src="../assets/images/druguse.png" alt="" class="md:w-2/5 " >

            <div class="flex flex-col my-0 mb-16 md:mb-0 md:my-32 p-2  md:ml-44 md:w-5/5 ">
                <h3 class=" text-black font-semibold text-2xl text-center  md:text-3xl md:text-left">MedRemind ensures that your patients don't miss a dose. </h3>
                <h1 class="  text-medalertBlue font-semibold text-2xl text-center  md:text-3xl md:text-left mt-8 ">Do you own a pharmacy or clinic? </h1>
                

                <div class="flex mt-2 md:order-2 justify-center md:justify-start">
                    <router-link to="/register" ><button type="button" class="text-white w-full bg-medalertOrange hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg px-8 py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-blueHover  dark:focus:ring-purple  ">Get started for free</button></router-link>
                </div>
            </div>
        </div>

        <!-- HOW IT WORKS SECTION -->

        <div id="howItWorks"  class="mt-20 bg-medalertBlue bg-opacity-10 px-8 md:px-20 py-24">

            <h1 class=" first-letter:text-3xl text-black text-xl font-euclid font-semibold ">How MedRemind Works</h1>

            <div class=" justify-between font-euclid mt-7 md:flex-row flex flex-col ">

                <div class="flex flex-col font-semibold items-center md:justify-center ">
                    <div class="px-16"><img src="../assets/images/illustration1.png" alt="" class="my-5 w-24"></div>
                    <h3 class="text-medalertOrange text-lg">STEP 1</h3>
                    <h3 class="text-black my-3 text-xl md:text-lg" >Create an account</h3>
                    <p class="text-black justify-center md:text-justify w-4/5 md:w-60 font-medium">Get Started by completing our registration form. To create your account, we collect information about you and your business.</p>
                </div>

                <div class="flex flex-col font-semibold items-center md:justify-center">
                    <div class="px-16"><img src="../assets/images/illustration2.png" alt="" class="my-5 w-24"></div>
                    <h3 class="text-medalertOrange text-lg">STEP 2</h3>
                    <h3 class="text-black my-3 text-xl md:text-lg" >Set medication reminder</h3>
                    <p class="text-black justify-center md:text-justify w-4/5 md:w-60 font-medium">Create medication reminders by providing your patient’s phone number, prescription, and start date </p>
                </div>

                <div class="flex flex-col font-semibold items-center md:justify-center">
                    <div class="px-16"><img src="../assets/images/illustration3.png" alt="" class="my-5 w-24"></div>
                    <h3 class="text-medalertOrange text-xl md:text-lg">STEP 3</h3>
                    <h3 class="text-black my-3 text-lg" >Patient receive reminder</h3>
                    <p class="text-black justify-center md:text-justify w-4/5 md:w-60 font-medium">Your patients receive SMS reminders that contain the prescribed drugs and dosage until the medication is completed.</p>
                </div>

            </div>
         

        </div>

            <!-- ABOUT SECTION -->

            <div id="about" class=" bg-gray-500 bg-opacity-10 px-8 md:px-20 py-20 font-euclid flex flex-col justify-center    align-middle content-center">

                <h1 class="first-letter:text-3xl text-black text-xl font-euclid font-semibold">About MedRemind</h1>

                <p class="text-black my-7 text-lg text-justify">MedRemind is a product of AutoHealth Technologies, a Software as a Service company in the healthcare industry. MedRemind helps pharmacies and hospitals to automate medication reminders for their patients. The platform utilizes Short Message Service (SMS) to deliver medication reminders until the last dose. Our goal is to improve treatment outcomes by ensuring that your patients take their medications as prescribed.</p>


                <div class=" mt-12">
                <router-link to="/register" ><button type="button" class="text-white bg-medalertBlue hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg px-16  md:px-24 py-3 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-blueHover dark:focus:ring-purple font-euclid">Get started for free</button></router-link>
                </div>

            </div>


        <!-- CONTACT US -->

        <div id="contact" class="bg-white px-2 md:px-20 py-20 font-euclid flex flex-col">

            <h1 class="first-letter:text-3xl text-black text-xl font-euclid font-semibold"> Contact Us </h1>

            <div
            v-if="success"
            class=" border w-2/5 mx-auto mt-2 bg-medalertBlue border-medalertBlue text-white px-4 py-3 rounded relative"
            role="alert">
                <strong class="font-bold mx-2">Thank you!</strong>
                <span class="">{{ success }}</span>
            </div>

            <div
                v-if="err"
                class=" border w-2/5 mx-auto mt-2 bg-medalertOrange border-medalertOrange text-white px-4 py-3 rounded relative"
                role="alert">
                    <strong class="font-bold mx-2">Error!</strong>
                    <span class="">{{ err }}</span>
            </div>

            <div class=" my-12 mx-auto py-5  md:w-2/5 shadow-2xl  ">
                <form action="" @submit.prevent="handleContactMessage">
                    <div class="flex flex-col text-start mx-12 my-5">
                        <label for="">Full name</label>
                        <input v-model="fullName" type="text" required  class=" rounded-lg form-control block px-3 py-2 text-base font-normal text-gray-700
                        bg-white bg-clip-padding border border-solid border-gray-300 roundedtransition ease-in-out m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter full name" >
                    </div>

                    <div class="flex flex-col text-start mx-12 my-5">
                        <label for="">Phone number</label>
                        <input v-model="phone" type="number"  class=" rounded-lg form-control block px-3 py-2 text-base font-normal text-gray-700
                        bg-white bg-clip-padding border border-solid border-gray-300 roundedtransition ease-in-out m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Phone number">
                    </div>

                    <div class="flex flex-col text-start mx-12 my-5">
                        <label for="">Email</label>
                        <input v-model="email" type="email" required class=" rounded-lg form-control block px-3 py-2 text-base font-normal text-gray-700
                        bg-white bg-clip-padding border border-solid border-gray-300 roundedtransition ease-in-out m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Email address " >
                    </div>

                    <div class="flex flex-col text-start mx-12 my-5">
                        <label for="">Message</label>
                        <textarea v-model="message" name="" id="" required cols="30" rows="3" type="text"  class=" rounded-lg form-control block px-3 py-2 text-base font-normal text-gray-700
                        bg-white bg-clip-padding border border-solid border-gray-300 roundedtransition ease-in-out m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder="Enter message" ></textarea>

                        <div class=" mt-6">
                        <button
                        :disabled="inactive"
                        :class="inactive ? 'cursor-not-allowed' : ''"  type="submit"   class="text-white disabled:bg-gray-200 bg-medalertBlue hover:bg-blueHover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg w-full py-2 text-center mr-3 md:mr-0 dark:bg-purple dark:hover:bg-blueHover dark:focus:ring-purple font-euclid">Submit
                        <!-- <span v-if="isLoading">
                            <Loading />
                        </span> -->
                        </button>
                        </div>

                    </div>
                </form>

            </div>
        </div>


        <!-- FOOTER SECTION -->

        <div class="flex flex-col bg-black justify-center  text-white bg-opacity-95 font-euclid">

            <div class=" w-full pt-14 pb-10 px-20 h-auto   align-middle md:flex-row justify-between sm:flex flex-col">

                <div class="flex flex-col text-left">
                    <h3 class="w-52 " >2, Olumide Balogun Close, Obaotudeko Avenue, Idi-Ishin, Ibadan, Oyo State, Nigeria </h3>
                    <div class="my-5">
                        <h3 class="w-52 " > +2347033843810 </h3>
                        <h3 class="w-52 " > +2349035720729 </h3>
                        <h3 class="w-52 " > +2347038411492 </h3>
                    </div>
                    
                    <h3 class="">autohealthtech@gmail.com</h3>
                    
                </div>

                <div class="flex flex-col mt-4 md:mt-0">
                    <h3 class="w-52 text-left hover:cursor-pointer" > Terms and Conditions </h3>
                    <h3 class="w-52 text-left hover:cursor-pointer" > Privacy policy </h3>
                </div>

                <div  class="social-links text-medalertOrange flex justify-start">
                    <span class="cursor-pointer mr-2"
                        ><i class="hover:text-white ri-facebook-box-fill ri-2x"></i
                    ></span>
                    <span class="cursor-pointer mx-2"
                        ><i class="hover:text-white ri-instagram-line ri-2x"></i
                    ></span>
                    <span class="cursor-pointer mx-2"
                        ><i class="hover:text-white ri-linkedin-box-fill ri-2x"></i
                    ></span>
                    <span class="hover:text-white cursor-pointer mx-2"
                        ><i class="ri-twitter-line ri-2x"></i
                    ></span>
                </div>
            
            </div>

            <div class="text-start px-20 md:mx-auto pb-4">
                <h3 class="  md:text-left text-white "  > Copyright © 2022 MedRemind </h3>
            </div>

        </div>

        



            
    </div>


</div>
  
</template>



<script>


import { ref } from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'

import navBar from '../components/NavBar'
import Loading from "../components/Loading";
import NavBar2 from '@/components/NavBar2.vue'

export default {

    components:{navBar, NavBar2, Loading},

    setup(){
        
        const store = useStore()
        const router = useRouter()

        const isLoading = ref(false);
        const inactive = ref(false);
        
        const err = ref('')
        const success = ref('')
        console.log(success)


        const fullName = ref('')
        const email = ref('')
        const phone = ref('')
        const message = ref('')
        

        const handleContactMessage = async () => {

            try {
                inactive.value = true
                // isLoading.value = true;
                await store.dispatch('contactUsMessage', 
                {name: fullName.value, 
                email: email.value, 
                phone_number: phone.value, 
                message: message.value });

                (fullName.value = "", 
                phone.value = "", 
                email.value = "", 
                message.value = "")

                success.value = "Message sent successfully";
                console.log(success.value)

                setTimeout(() => {
                success.value = "";
                }, 3000);
                // isLoading.value = false;
                inactive.value = false
            }   
            catch(error) {
                // isLoading.value = false;
                inactive.value = false
                err.value = error
                console.log(err.value)
                setTimeout(() => {
                err.value = "";
                }, 3000);
            }
            
        }

    return{
       
        fullName,
        email,
        phone,
        message,
        err,
        success,
        isLoading,
        inactive,
        handleContactMessage
     
    } 


    }, 
    



}



</script>



<style scoped>

/* .footerSection{
    background-image: linear-gradient(
        rgba(0, 0, 0, 0.9),
        rgba(2, 0, 3, 0.9)

    ),
    url('../assets/images/clock.png');
} */


</style>